'use client';

import React from 'react';
import {SubscriptionPlan} from '@/generated/graphql';
import {useI18n} from '@udemy-v2/i18n';

import {FeatureSelector} from './feature-selector';
import styles from './features.module.scss';
import {FeaturesCta} from './features-cta';
import {PageForType} from '../../types/page';
import {getFeaturesCtaTexts} from './features-cta.constants';

interface FeaturesProps {
    pageFor: PageForType;
    subscriptionPlans?: SubscriptionPlan[] | null;
    countryCode?: string | null;
}

const Features: React.FC<FeaturesProps> = ({pageFor, subscriptionPlans, countryCode}) => {
    const {gettext} = useI18n();
    const {title} = getFeaturesCtaTexts(gettext)[pageFor];

    return (
        <div className={styles.features_container}>
            <section>
                <h1 className={styles.title}>
                    {title}
                    <br />
                </h1>
            </section>
            <section>
                <FeatureSelector />
            </section>
            <section>
                <FeaturesCta
                    pageFor={pageFor}
                    subscriptionPlans={subscriptionPlans}
                    countryCode={countryCode}
                />
            </section>
        </div>
    );
};

export {Features};
